module.exports = __webpack_public_path__ + "favicon-72-e8061b14c73c73e8cd508864c3b9e000.bundle.png";